<template>
    <form @keyup="error = false">

        <input type="text" v-model="credentials.login" placeholder="Login" class="mt-1 leading-tight !bg-gray-700 !border-gray-900">
        <input type="password" v-model="credentials.password" placeholder="Heslo" class="mt-2 leading-tight !bg-gray-700 !border-gray-900">
        <div class="form__error static m-0 mt-2" v-if="error">Zadané údaje nejsou platné</div>

        <btn class="btn btn--primary mt-2 leading-tight"
            type="submit"
            @click.prevent.native="onSubmit()"
            :loading="sending"
            :disabled="sending || error"
        >
            Přihlásit
            <icon name="chevron-right"></icon>
        </btn>

        <a class="block px-1 py-4 text-sm text-gray-500 underline" v-if="error" :href="url('/password/forgot')">Zapomněli jste heslo?</a>
    </form>
</template>

<script>
export default {

    props: ['redirect'],

    data() {
        return {
            credentials: {},
            sending: false,
            error: false
        }
    },

    methods: {
        onSubmit() {
            this.sending = true;

            axios.post(url('/login'), this.credentials)

                .then(response => {
                    this.sending = false;

                    Notify.swal({
                        icon: 'success',
                        title: 'Vítejte',
                        timer: 2000
                    }).then(() => {
                        if (this.redirect) {
                            window.location.assign(url(this.redirect));
                            return;
                        }

                        window.location.reload();
                    });
                })

                .catch(errors => {
                    this.sending = false;

                    if (errors.response.status === 403) {
                        Notify.swal({
                            icon: 'error',
                            title: 'Registrace nebyla potvrzena',
                            text: 'potvrzovací odkaz byl odeslán na váš e-mail'
                        }).then(() => {
                            window.location.assign(errors.response.data.redirect);
                        });
                        return;
                    }

                    if (errors.response.status !== 422) {
                        console.log(errors.response);
                        alert('unexpected error');
                        return;
                    }

                    this.error = true;
                    this.credentials.password = null;
                });
        }
    }
}
</script>
